import * as React from 'react';

// NOTE // takes in an airline (i.e. 'AN', or 'TJ', or ' ' for general templates), a type ('text' or 'email'), and the route (pre-configured)
  export const getTemplateChoices = (airline, type, route) => {
    const generalTextTemplates = [
      {label: 'None', value: ''},
      {label: 'Flight Boarding', value: `Flight Status. Your flight ${route} is now boarding.`},
      {label: 'Flight Cancelled', value: `Flight Status. Your upcoming flight ${route} has been cancelled. We will contact you shortly regarding alternate arrangements.`},
      {label: 'Flight Delayed', value: `Flight Status. Your upcoming flight ${route} is delayed until {{new time}}.`}
    ]

    // NOTE // I spent the time making these when they weren't needed and don't want to delete them. =/
    const tjTextTemplates = [
      {label: 'Flight Delayed', value: `Flight Status. Your upcoming flight ${route} is delayed until {{new time}}. For any questions please call 800-376-7922.`},
      {label: 'Pre-flight Health', value: 'Hello, please fill out the pre-flight health questionnaire that has been sent to you via email prior to arriving at the airport. Thank you'},
      {label: 'Flight Boarding', value: `Flight Status. Your flight ${route} is now boarding. Please meet your pilot at the FBO customer service desk near the exit to the aircaft ramp.`},
      {label: 'Flight Boarding (HPN)', value: `Tradewind Flight Status (HPN). Your flight ${route} is now boarding. Please meet your pilot at the left of the main exit to the ramp near the eagle statue.`},
      {label: 'Flight Boarding (TEB)', value: `Tradewind Flight Status (TEB). Your flight ${route} is now boarding. Please meet your pilot at the exit door to the aircraft ramp.`},
      {label: 'Flight Boarding (ACK)', value: `Tradewind Flight Status (ACK). Your flight ${route} is now boarding. Please meet your pilot in the check-in tent.`},
      {label: 'Flight Boarding (MVY)', value: `Tradewind Flight Status (MVY). Your flight ${route} is now boarding. Please meet your pilot at the concierge podium near the parking lot.`},
      {label: 'Pre-flight Health & Link', value: 'Hello, please follow this link to fill out the pre-flight health questionnaire prior to arriving at the airport: http://trip.flytradewind.com/health. Thank you - Tradewind'}
    ]

    // NOTE // these email templates have the required properties for substitution data in the value (e.g. "test2 title name"), and are separated by spaces.
    // NOTE // the first word in value is the templateId
    const anEmailTemplates = [
      // {label: 'AN-General', value: 'an-general message'},
      // {label: 'TAOS-General', value: 'taos-general message'},
      {label:'CUSTOM', value: 'custom message'}
    ]

    const taosEmailTemplates = [
      {label: 'General', value: 'taos-general message'},
    ]

    if (type.toUpperCase() === 'TEXT') {
      if (airline.toUpperCase() === 'TAOS') {
        return generalTextTemplates
      }
      else if(airline.toUpperCase() === 'AN') {
        return generalTextTemplates
      }
    }
    else if (type.toUpperCase() === 'EMAIL') {
      if (airline.toUpperCase() === 'AN') {
        console.log("anEmailTemplates")
        return anEmailTemplates
      }
      else if(airline.toUpperCase() === 'TJ') {
        console.log("anEmailTemplates@@@@@@@@@")
        return taosEmailTemplates
      }
    }
  }